<template>
    <div class="outer-box" >
      <h4>Get verification status</h4>
  
      <div class="inner-box" style="text-align: left; width: 500px;">
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Enter Agency Relationship Number"
          v-model.trim="relationshipNumber"
        />
        <p v-if="error" style="color: red;">{{errorMsg}}</p>
        <button class="btn btn-primary mt-4" @click="fetchVerificationStatus" :disabled="!relationshipNumber || processing || error">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Fetch Verification Status </span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
  import { OnboardingService, InternalToolsService } from "@/services";
  import * as moment from "moment";
  export default {
    data() {
      return {
        moment,
        relationshipNumber: '',
        processing: false,
        response: null,
        error: false,
        errorMsg: ''
      };
    },
    watch: {
      relationshipNumber(value) {
        this.validateRelationshipNumber(value);
      }
    },
    methods: {
      async validateRelationshipNumber(value) {
        this.error = false

        let regex = /^\d{1}-\d{3}-\d{3}$/;
        const isValidFormat = regex.test(value)

        if(!isValidFormat) {
          this.error = true
          this.errorMsg = 'Please check relationship number format. Eg: X-XXX-XXX'
        }
      },
      async fetchVerificationStatus(){
        try {
          this.processing = true
          this.error = false
          
          const { data: companyData } = await InternalToolsService.getCompanyByRelationshipNumber({ value: this.relationshipNumber })
          let companyId = companyData?.id;
      
          const {data} = await OnboardingService.fetchEmailVerificationStatus(companyId);

          if(data.success && data.result) {
            this.response = data.result.data
            if('dateAdded' in companyData) {
              this.response.accountCreationDate = moment(companyData?.dateAdded).format('DD-MMM-YYYY HH:mm:ss Z')
            }
            if(this.response.verificationDate) {
              this.response.verificationDate = moment(this.response.verificationDate).format('DD-MMM-YYYY HH:mm:ss Z')
            }
          } else {
              this.response = data.message
          }

          this.processing = false;
        } catch (error) {
            this.processing = false;
            this.response = 'Agency Relationship Number not found'
            console.error(error)
        }
        
      },
    }
  }
  </script>
  
  <style>
  </style>
  